<template>
	<button
		@click="$emit('click')"
		:class="{ 'star': isStar, 'chevron-right': isArrow, 'chevron-left': isArrowLeft, 'chevron-down': isArrowDown, 'chevron-up': isArrowUp }"
	>
		<span
			:class="{'transparent' : loading}"
			v-html="content"
		/>
		<loading-spin
			v-if="loading"
			:white="true"
		/>
	</button>
</template>

<script type="text/javascript">

export default {
	data () {
		return {

		}
	},

	props: {
		content: {
			type: String,
			default: null
		},
		isWithLoader: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		isArrow: {
			type: Boolean,
			default: false
		},
		isArrowLeft: {
			type: Boolean,
			default: false
		},
		isArrowDown: {
			type: Boolean,
			default: false
		},
		isArrowUp: {
			type: Boolean,
			default: false
		},
		isStar: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
.btn,
.btn:hover, 
.btn:active {
	margin: 0;
	padding: 0.375rem 0.75rem;
}

button {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}
.transparent {
	opacity: 0;
}

* >>> .loading-outer {
	position: absolute !important;
	left: 50%;
    transform: translateX(50%) scale(0.6);
}

</style>